import React from "react";

export default function MapMarkerIcon({color}) {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 0.400024C4.02343 0.400024 0.799988 3.62346 0.799988 7.60002C0.799988 13.6 7.99999 19.6 7.99999 19.6C7.99999 19.6 15.2 13.6 15.2 7.60002C15.2 3.62346 11.9765 0.400024 7.99999 0.400024ZM7.99999 11.2C6.01183 11.2 4.39999 9.58819 4.39999 7.60002C4.39999 5.61186 6.01183 4.00002 7.99999 4.00002C9.98815 4.00002 11.6 5.61186 11.6 7.60002C11.6 9.58819 9.98815 11.2 7.99999 11.2Z"
        fill={color||"#0086C0"}
      />
    </svg>
  );
}
